import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, forkJoin, map, switchMap, of } from 'rxjs';
import {
  loadParticipations,
  loadParticipationsSuccess,
  loadParticipationsFailure,
  resetParticipations,
} from './participations.action';
import { ChallengeService } from 'src/app/services/challenge.service';
import { StorageService } from 'src/app/services/storage.service';
import { logout } from '../auth/auth.actions';
import { Participation } from 'src/app/models/participation.model'; // ✅ Añadimos el tipo

@Injectable()
export class ParticipationsEffects {
  constructor(
    private actions$: Actions,
    private challengeService: ChallengeService,
    private storageService: StorageService
  ) {}

  /**
   * 🧹 Al hacer logout, limpiamos el store de participaciones
   */
  logout$ = createEffect(() =>
    this.actions$.pipe(ofType(logout), map(() => resetParticipations()))
  );

  /**
   * 🔹 Cargar participaciones del usuario desde Firestore + generar URLs firmadas seguras
   */
  loadParticipations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadParticipations),
      switchMap(({ userId }) =>
        this.challengeService.getParticipationsByUserId(userId).pipe(
          switchMap((participations: Participation[]) => {
            if (!participations || participations.length === 0) {
              console.log('⚠️ No hay participaciones para este usuario');
              return of([] as Participation[]);
            }

            // 🔒 Manejo seguro de mediaUrl (evita undefined)
            const updated = participations.map((p) => {
              const safeUrl = p.mediaUrl ?? '';
              return this.storageService.getSignedUrl(safeUrl).pipe(
                map((url) => ({
                  ...p,
                  mediaUrl: url || safeUrl, // si no devuelve URL, usa la original
                }))
              );
            });

            // 🧩 Espera a que se completen todas las URLs antes de emitir
            return forkJoin(updated);
          }),
          map((participations: Participation[]) =>
            loadParticipationsSuccess({ participations })
          ),
          catchError((error) => {
            console.error('❌ Error al cargar participaciones:', error);
            return of(
              loadParticipationsFailure({ error: error?.message || 'Error desconocido' })
            );
          })
        )
      )
    )
  );
}
